import { IDevice } from '@pages/Assets/Inventory/types';
import { useCallback } from 'react';
import { IDeviceActionRequestPayload } from '../types';

interface IActionNetworkReset {
  devicesProps: IDevice[] | undefined;
  uploadedDevices: any;
  actionKey: number;
  handleDeviceActions: (item: IDeviceActionRequestPayload) => void;
}

const useActionNetworkReset = ({
  actionKey,
  devicesProps,
  uploadedDevices,
  handleDeviceActions,
}: IActionNetworkReset) => {
  const contentSteps: [] = [];

  const onSubmit = useCallback(async () => {
    const payload: IDeviceActionRequestPayload = {};
    payload.action = actionKey;

    payload.devices =
      devicesProps && devicesProps.length > 0
        ? devicesProps?.map(device => ({
            msisdn: device.msisdn,
          }))
        : uploadedDevices;
    return handleDeviceActions(payload);
  }, [actionKey, devicesProps, uploadedDevices, handleDeviceActions]);

  const networkResetData = {
    contentSteps,
    onSubmit,
  };

  return { networkResetData };
};

export default useActionNetworkReset;
